import { parseWebSocketMessageSamples } from '@terra/shared-asset-processing';
import type { StreamingMessageRow } from '../streaming-messages/streaming-messages.types';
import { resolveStreamingMessageDataType } from '../streaming-messages/try-format-json';

const UNIX_SECONDS_THRESHOLD = 1_000_000_000;
const DATA_PREVIEW_CHARS = 500;

function toTimestamp(time: number | undefined): Date | undefined {
  if (time === undefined || time < UNIX_SECONDS_THRESHOLD) {
    return undefined;
  }

  return new Date(time * 1000);
}

export function mapHarWebSocketMessagesToStreamingView(
  rawMessages: unknown,
): StreamingMessageRow[] {
  return parseWebSocketMessageSamples(rawMessages)
    .filter((message) => message.opcode !== 'ping' && message.opcode !== 'pong')
    .map((message, index) => {
      const dataType = resolveStreamingMessageDataType({
        isBinary: message.opcode === 'binary',
        data: message.data,
        truncated: message.truncated,
      });
      const dataSize = new TextEncoder().encode(message.data).length;

      return {
        id: `har-ws-${index}`,
        sequentialId: index + 1,
        direction: message.direction === 'send' ? 'sent' : 'received',
        timestamp: toTimestamp(message.time),
        dataType,
        dataPreview:
          message.data.length > DATA_PREVIEW_CHARS
            ? `${message.data.slice(0, DATA_PREVIEW_CHARS)}...`
            : message.data,
        dataSize,
        data: message.data,
      };
    });
}
